import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../assets/images/logo.png";

export function useDoubleTickWidget() {
  const location = useLocation();
  const isShowSetupMenu = useSelector((state) => state.auth?.isShowSetupMenu) || false;
  
  useEffect(() => {
    // Only show widget on registration pages or when setup dialog is open
    const isRegistrationPage = location.pathname.includes('/register') || 
                               location.pathname.includes('/business/get-started');
    const shouldShowWidget = isRegistrationPage || isShowSetupMenu;
    
    // Hide widget if not on registration page and setup dialog is closed
    if (!shouldShowWidget && window.dt) {
      // Try to hide the widget by finding and hiding its container
      // The widget typically creates an iframe or div with specific classes
      const widgetSelectors = [
        'iframe[src*="doubletick"]',
        'iframe[src*="d3r49s2alut4u1"]',
        'div[id*="dt-widget"]',
        'div[class*="dt-widget"]',
        '[data-dt-widget]',
        '#dt-widget',
        '.dt-widget'
      ];
      
      widgetSelectors.forEach(selector => {
        try {
          const widgetElement = document.querySelector(selector);
          if (widgetElement) {
            widgetElement.style.display = 'none';
            widgetElement.style.visibility = 'hidden';
            widgetElement.style.opacity = '0';
            widgetElement.style.pointerEvents = 'none';
          }
        } catch (e) {
          // Ignore selector errors
        }
      });
      
      // Also try to hide by checking all iframes
      const allIframes = document.querySelectorAll('iframe');
      allIframes.forEach(iframe => {
        if (iframe.src && (iframe.src.includes('doubletick') || iframe.src.includes('d3r49s2alut4u1'))) {
          iframe.style.display = 'none';
          iframe.style.visibility = 'hidden';
          iframe.style.opacity = '0';
          iframe.style.pointerEvents = 'none';
        }
      });
      
      return;
    }

    // Only initialize on registration pages or when setup dialog is open
    if (!shouldShowWidget) return;

    // Prevent loading twice
    if (window.dt) {
      // Show widget if it already exists
      const widgetSelectors = [
        'iframe[src*="doubletick"]',
        'iframe[src*="d3r49s2alut4u1"]',
        'div[id*="dt-widget"]',
        'div[class*="dt-widget"]',
        '[data-dt-widget]',
        '#dt-widget',
        '.dt-widget'
      ];
      
      widgetSelectors.forEach(selector => {
        try {
          const widgetElement = document.querySelector(selector);
          if (widgetElement) {
            widgetElement.style.display = 'block';
            widgetElement.style.visibility = 'visible';
            widgetElement.style.opacity = '1';
            widgetElement.style.pointerEvents = 'auto';
          }
        } catch (e) {
          // Ignore selector errors
        }
      });
      
      // Also show iframes
      const allIframes = document.querySelectorAll('iframe');
      allIframes.forEach(iframe => {
        if (iframe.src && (iframe.src.includes('doubletick') || iframe.src.includes('d3r49s2alut4u1'))) {
          iframe.style.display = 'block';
          iframe.style.visibility = 'visible';
          iframe.style.opacity = '1';
          iframe.style.pointerEvents = 'auto';
        }
      });
      
      return;
    }

    (function (w, d, s, o, f) {
      w[o] =
        w[o] ||
        function () {
          (w[o].q = w[o].q || []).push(arguments);
        };

      const js = d.createElement(s);
      const fjs = d.getElementsByTagName(s)[0];
      js.id = o;
      js.src = f;
      js.async = true;
      fjs.parentNode.insertBefore(js, fjs);
    })(
      window,
      document,
      "script",
      "dt",
      "https://d3r49s2alut4u1.cloudfront.net/js/widget.js"
    );

    // Init AFTER script load (queued safely)
    window.dt("init", {
      crmWidgetId: "53ecd9d6-be5e-4427-9d0a-3b8a1787dcf8",
      companyName: "beemz",
      companyLogoUrl: logo,
      phoneNumber: "918105405606",
    });
  }, [location.pathname, isShowSetupMenu]);
}
